import React from 'react';
import { RhColumns, RhNumberField } from '../../../../../../../dum';
import { OrderAdjustmentProductInput } from './product/product-input';
import { IOrderSale } from '../../order-sale-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';
import { ReturnLineTotal } from './return-totals';

type OrderAdjustmentColumn = NonNullable<
    IOrderSale['order_adjustment_products']
>[number];

const defaultValue: OrderAdjustmentColumn = {
    product_id: null,
    kilos: 0,
    groups: 0,
};

export const ORDER_ADJUSTMENT_PRODUCTS: keyof IOrderSale =
    'order_adjustment_products';
export const KILOS: keyof OrderAdjustmentColumn = 'kilos';
export const GROUPS: keyof OrderAdjustmentColumn = 'groups';

export function OrderAdjustmentProductsColumns() {
    return (
        <RhColumns
            viewOnly
            name={ORDER_ADJUSTMENT_PRODUCTS}
            defaultValue={defaultValue}
            items={[
                {
                    cellGrow: 5,
                    getField: (index) => {
                        return <OrderAdjustmentProductInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RhNumberField
                                disabled
                                name={`${ORDER_ADJUSTMENT_PRODUCTS}.${index}.${GROUPS}`}
                                label={shortLabel(FIELD_LABELS.groups)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RhNumberField
                                disabled
                                name={`${ORDER_ADJUSTMENT_PRODUCTS}.${index}.${KILOS}`}
                                label={shortLabel(FIELD_LABELS.kilos)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    getField: (index) => {
                        return <ReturnLineTotal index={index} />;
                    },
                },
            ]}
        />
    );
}
